import { dataExpandSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconExpandSquare = /*#__PURE__*/createIcon(dataExpandSquare)
export default IconExpandSquare
